import {Assignment, OpenInNew} from "@mui/icons-material";
import {Button, Paper} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useNavigate} from "react-router";
import {_Sitemap} from "@localization/siteMap/breadcrumbs/_Sitemap.ts";

export const RecursosIndexPage = () => {
    const navigate = useNavigate()

    return (
        <DefaultContainer titulo={'recurso'} size={'medium'} component={Paper}>
            <Button endIcon={<Assignment/>}
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate('/recurso/gerenciamento')}
                    fullWidth>
                Gerenciamento de recursos
            </Button>
            <Button endIcon={<OpenInNew/>}
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate(_Sitemap.recurso.children.movimentacoes.fullUrl)}
                    fullWidth>
                Movimentações
            </Button>
        </DefaultContainer>
    );
}